var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-cart_svg__clip0_32322_42885)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.833 14.667a.667.667 0 100-1.334.667.667 0 000 1.334zM6.5 14.667a.667.667 0 100-1.334.667.667 0 000 1.334zM1.167.667h2.666L5.62 9.593a1.334 1.334 0 001.333 1.074h6.48a1.334 1.334 0 001.334-1.074L15.833 4H4.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-cart_svg__clip0_32322_42885"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/icon-cart.668ae486.svg";
export { SvgIconCart as ReactComponent };